export function getSalaryBracketFromArray(bracket: number[] | string[]) {
  if (bracket.length === 2) {
    return `от ${bracket[0]} до ${bracket[1]} р.`;
  }
  if (bracket.length === 1) {
    return `от ${bracket[0]} р.`;
  }
  return 0;
}
